// Modules
import React from 'react';

// Styles
import styles from './CustomHR.module.scss';

const CustomHR = (props) => {
  const { extraStyles = {} } = props;

  return <hr className={styles.hr} style={extraStyles} />;
};

export default CustomHR;
